import { GoCircle } from 'react-icons/go';
import styled, { css } from 'styled-components';

const Main = styled.div`
  width: 100%;
`;

const FormContainer = styled.div`
  margin-left: 25px;
  margin-right: 25px;
`;

const StatusCircle = styled(GoCircle)`
  margin-left: 8px;
  ${(props) => {
    switch (props.status) {
      case 'active':
        return css`
          color: ${props.theme.COLOR_STATUS_GREEN};
        `;
      case 'new':
        return css`
          color: ${props.theme.COLOR_STATUS_BLUE};
        `;
      case 'suspended':
        return css`
          color: ${props.theme.COLOR_STATUS_ORANGE};
        `;
      default:
        return null;
    }
  }}
`;

const Bumper = styled.div`
  height: 24px;
`;

const TooltipContainer = styled.div`
  margin-left: auto;
`;

const RadioButtonContainer = styled.div`
  width: 100%;
`;

const RadioButtonGroup = styled.div`
  align-items: center;
  display: flex;
  margin-top: 30px;
  justify-content: center;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-top: 40px;
  height: 79px;
  padding: 20px;
  background-color: ${({ theme }) => theme.COLOR_BG_LIGHT};
  border-radius: 0 0 4px 4px;
`;

const categoriesAddEditFormStyle = {
  FormContainer,
  StatusCircle,
  Bumper,
  TooltipContainer,
  RadioButtonGroup,
  RadioButtonContainer,
  ButtonContainer,
  Main,
};

export default categoriesAddEditFormStyle;
